import React from 'react';
import { Calendar, Clock, MapPin, Search } from 'lucide-react';
import { Button } from './Button';

export const Appointment: React.FC = () => {
  return (
    <section className="py-24 bg-blue-600 relative overflow-hidden">
      {/* Background patterns */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-white/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold leading-tight">
              Ready to see a <br/> Specialist?
            </h2>
            <p className="text-blue-100 text-lg max-w-lg leading-relaxed">
              Book an appointment in seconds. Choose your specialist, select a time, and get confirmed instantly via the app.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
               <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-lg">
                  <Clock size={18} className="text-blue-200" />
                  <span className="text-sm font-semibold">Average wait: 2 mins</span>
               </div>
               <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-lg">
                  <Calendar size={18} className="text-blue-200" />
                  <span className="text-sm font-semibold">Today's slots available</span>
               </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-2xl">
             <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
                <div className="space-y-2">
                    <label className="text-sm font-bold text-gray-700 ml-1">Specialty</label>
                    <div className="relative">
                        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        <select className="w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none appearance-none font-medium text-gray-600">
                            <option>General Practitioner</option>
                            <option>Cardiologist</option>
                            <option>Urologist</option>
                            <option>Dermatologist</option>
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                        <label className="text-sm font-bold text-gray-700 ml-1">Date</label>
                        <div className="relative">
                            <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                            <input type="date" className="w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none font-medium text-gray-600" />
                        </div>
                    </div>
                    <div className="space-y-2">
                         <label className="text-sm font-bold text-gray-700 ml-1">Location</label>
                         <div className="relative">
                            <MapPin className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                            <select className="w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none appearance-none font-medium text-gray-600">
                                <option>Video Call</option>
                                <option>Clinic Visit</option>
                            </select>
                        </div>
                    </div>
                </div>

                <Button className="w-full py-4 text-lg shadow-xl shadow-blue-500/20">
                    Find Available Doctors
                </Button>
             </form>
          </div>
        </div>
      </div>
    </section>
  );
};